// libs
import { connect } from 'react-redux';

// redux
import { getProductData, getProductId, getProductOutOfStock } from 'shared/store/details/selectors';

// components
import RecentlyViewedObserver from './RecentlyViewedObserver';

const mapStateToProps = (state: any) => ({
  data: getProductData(state),
  productID: getProductId(state),
  isOutOfStock: getProductOutOfStock(state),
});

export default connect(mapStateToProps)(RecentlyViewedObserver);
